interface GoogleItemListJsonProps {
  products: {
    name: string
    url: string
    position: number
  }[]
}

interface GoogleItemListElement {
  '@type': 'ListItem'
  position: number
  url?: string
  name?: string
  item?: string
}

interface GoogleItemList {
  '@context': 'https://schema.org'
  '@type': 'ItemList'
  itemListElement: GoogleItemListElement[]
}

export function GoogleItemListJson(props: GoogleItemListJsonProps) {
  const { products } = props

  const jsonLdSchema: GoogleItemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: products.map(product => {
      return {
        '@type': 'ListItem',
        position: product.position,
        url: product.url,
        name: product.name,
      }
    }),
  }

  return (
    <script
      key="google-item-list-structured-data"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdSchema) }}
    />
  )
}
